import hexToRgba from "hex-to-rgba";

export default {
  methods: {
    hexToRgba($hex, $opacity) {
      return hexToRgba($hex, $opacity);
    }
  }
};
